const messages = {
  it: {
    translations: {
      signup: {
        title: "Registrazione",
        toasts: {
          success: "Utente creato con successo! Accedi ora.",
          fail: "Errore nella creazione dell'utente. Verifica i dati inseriti.",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Registrati",
          login: "Hai già un account? Accedi!",
        },
      },
      login: {
        title: "Accedi",
        form: {
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Accedi",
          register: "Non hai un account? Registrati!",
        },
      },
      auth: {
        toasts: {
          success: "Sessione avviata con successo!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Chat oggi: ",
          },
        },
        messages: {
          inAttendance: {
            title: "In gestione"
          },
          waiting: {
            title: "In attesa"
          },
          closed: {
            title: "Risolti"
          }
        },
        titulo: "Dashboard",
        summaryBanner: "Visualizzazione dati dal {{from}} al {{to}} per {{userName}}",
        filters: {
          title: "Filtri",
          show: "Mostra filtri",
          hide: "Nascondi filtri"
        }
      },
      connections: {
        outboundPause: {
          chip: "INVII IN PAUSA",
          switchLabel: "Messaggi in uscita",
          active: "Attivi",
          paused: "IN PAUSA",
          pausedHelp: "Nessun messaggio esce da questa connessione: né dalla chat, né dall'IA, né modelli, né promemoria. Restano nella chat segnati come non inviati.",
          confirmTitle: "Mettere in pausa gli invii di {{name}}?",
          confirmMessage: "Finché è in pausa, NESSUN messaggio uscirà da questa connessione: risposte della chat, dell'IA, modelli, conferme e promemoria degli appuntamenti. I messaggi in arrivo continuano a essere ricevuti. Ricordati di riattivarla.",
          confirmButton: "Metti in pausa",
          toastPaused: "Invii di {{name}} IN PAUSA.",
          toastResumed: "Invii di {{name}} riattivati.",
        },
        title: "Connessioni",
        empty: "Non ci sono ancora connessioni.",
        toasts: {
          deleted: "Connessione WhatsApp eliminata con successo!",
          restarted: "Connessione riavviata con successo",
          newDefault: "{{name}} è ora la tua connessione predefinita.",
        },
        defaultChanged: {
          message: "La tua connessione predefinita è cambiata a {{name}}. Se ne vuoi un'altra, cambiala qui.",
          change: "Cambia",
          ack: "Ho capito",
        },
        metaHealth: {
          checking: "Verifica dello stato…",
          refresh: "Aggiorna stato",
          blockingChip: "Blocca l'invio",
          blockingNote: "Questo impedisce al tuo numero di inviare messaggi finché non lo risolvi.",
          nonBlockingNote: "Non impedisce il funzionamento, ma conviene risolverlo.",
          ok: { title: "Connessione attiva", desc: "Il tuo numero Meta è pronto per inviare e ricevere." },
          billing_missing: { title: "Manca la configurazione del pagamento", desc: "Il tuo numero NON PUÒ inviare messaggi finché non configuri un metodo di pagamento su Meta. Questo è ciò che sta bloccando l'invio in questo momento.", descDetected: "Abbiamo rilevato che Meta ha rifiutato un invio per mancanza di metodo di pagamento. Se hai già aggiunto una carta, prova a inviare di nuovo; se il problema persiste, controlla il Centro fatturazione.", action: "Configura pagamento" },
          payment_unverified: { title: "Non possiamo verificare il metodo di pagamento", desc: "Non abbiamo ancora confermato un invio riuscito con questo numero. Se un invio fallisce, potrebbe mancare una carta configurata su Meta.", action: "Controlla pagamento" },
          register_needed: { title: "Manca l'attivazione del numero", desc: "Il tuo numero è verificato ma non ancora attivato per l'invio. Possiamo attivarlo da qui.", action: "Riprova registrazione", retrying: "Attivazione…", retryOk: "Numero attivato. Aggiornamento stato…", retryFail: "Impossibile attivare il numero. Riprova tra poco." },
          pending: { title: "Meta sta esaminando il tuo numero", desc: "Meta sta ancora verificando il tuo numero. Può richiedere un po' di tempo; per ora non c'è nulla da fare da parte tua." },
          name_declined: { title: "Nome rifiutato", desc: "Meta ha rifiutato il nome visibile del numero. Questo NON blocca l'invio né la ricezione di messaggi; conviene comunque cambiarlo per migliorare la consegna: nella schermata del numero, vai su Profilo → Nome visualizzato.", action: "Cambia nome" },
          quality_low: { title: "Qualità del numero bassa", desc: "Meta ha abbassato la qualità del tuo numero. Puoi ancora inviare e ricevere, ma modera il ritmo di invio per non perdere l'abilitazione." },
          no_templates: { title: "Nessun template approvato", desc: "Non hai template approvati. Puoi rispondere normalmente entro 24 ore, ma serve un template per avviare nuove conversazioni fuori da quella finestra.", action: "Crea template" },
          check_failed: { title: "Impossibile verificare", desc: "Non siamo riusciti a consultare lo stato su Meta in questo momento. Riprova tra poco." },
          qualityChip: "Qualità: {{quality}}",
          quality: { GREEN: "Alta", YELLOW: "Media", RED: "Bassa" },
        },
        confirmationModal: {
          deleteTitle: "Elimina",
          deleteMessage: "Sei sicuro? Questa azione non può essere annullata.",
          disconnectTitle: "Disconnetti",
          disconnectMessage: "Sei sicuro? Dovrai scansionare nuovamente il codice QR.",
          disconnectMessageMeta: "Sei sicuro di voler disconnettere questa connessione Meta?",
          restartTitle: "Riavvia connessione",
          restartMessage: "Riavviare la connessione? Tutti i dati e le configurazioni saranno preservati. La connessione si riconnetterà e mostrerà un nuovo codice QR.",
          restartMessageMeta: "Riprovare la connessione? Tutti i dati e le configurazioni saranno preservati. La connessione Meta verrà ristabilita.",
        },
        buttons: {
          add: "Aggiungi WhatsApp",
          disconnect: "Disconnetti",
          tryAgain: "Riprova",
          qrcode: "CODICE QR",
          newQr: "NUOVO CODICE QR",
          connecting: "Connessione in corso",
          restart: "Riavvia",
          templates: "Template",
          edit: "Modifica",
          delete: "Elimina",
        },
        toolTips: {
          disconnected: {
            title: "Errore nell'avvio della sessione WhatsApp",
            content:
              "Assicurati che il tuo telefono sia connesso a internet e riprova, oppure richiedi un nuovo codice QR",
          },
          disconnectedMeta: {
            title: "La connessione Meta non è attiva",
            content:
              "La connessione Meta non è attiva. Clicca su 'Riprova' per ristabilirla.",
          },
          qrcode: {
            title: "In attesa di scansione del codice QR",
            content:
              "Fai clic sul pulsante 'CODICE QR' e scansiona il codice QR con il tuo telefono per avviare la sessione",
          },
          connected: {
            title: "Connessione stabilita!",
          },
          timeout: {
            title: "Connessione con il telefono persa",
            content:
              "Assicurati che il tuo telefono sia connesso a internet e che WhatsApp sia aperto, oppure fai clic su 'Disconnetti' per ottenere un nuovo codice QR",
          },
        },
        table: {
          name: "Nome",
          number: "Numero",
          type: "Tipo",
          status: "Stato",
          backup: "Riserva",
          lastUpdate: "Ultimo aggiornamento",
          default: "Predefinita",
          actions: "Azioni",
          session: "Sessione",
        },
        badges: {
          primary: "PRIMARIA",
          standby: "STANDBY",
          failover: "FAILOVER ATTIVO",
        },
        types: {
          qrPro: "WhatsApp QR — Pro",
          qrWeb: "WhatsApp QR — Web",
          metaCloud: "Meta Cloud API",
          coexistence: "Meta Coexistence",
          qrProDesc: "Stabile ed efficiente. L'opzione consigliata per la maggior parte.",
          qrWebDesc: "Massima compatibilità con tutti i dispositivi.",
          metaCloudDesc: "Connessione ufficiale certificata da Meta. Modelli e messaggi massivi.",
          coexistenceDesc: "Usa WhatsApp dal tuo cellulare e WAIA allo stesso tempo.",
          notEnabled: "Non abilitato",
        },
        alerts: {
          primaryDown: "La connessione {{name}} si è disconnessa. Controlla la pagina connessioni.",
          primaryDownWithStandby: "La connessione {{name}} si è disconnessa. Uso riserva {{standby}} automaticamente.",
          standbyDown: "La riserva {{name}} non è disponibile. Rimane solo la connessione principale.",
          primaryDownBothFailed: "La connessione {{name}} e la riserva {{standby}} sono entrambe disconnesse.",
        },
        stepSelectType: "Che tipo di connessione vuoi aggiungere?",
        stepConfigure: "Configurazione",
        noTypesEnabled: "Nessun tipo di connessione abilitato per questa azienda. Contatta l'amministratore.",
        backupConnection: "Connessione di riserva",
        noBackup: "Nessuna riserva",
        backupOf: "Riserva di:",
        unlinkBackup: "Scollega",
        allowedConnectionTypes: "Tipi di connessione consentiti",
      },
      connectionBanner: {
        pausedPrefix: "INVII IN PAUSA su",
        pausedSuffix: "Nessun messaggio esce da quella connessione.",
        prefix: "La connessione WhatsApp",
        statusDisconnected: "è disconnessa",
        statusWaitingQr: "è in attesa del QR",
        actionQr: "Scansiona il QR per riconnetterti.",
        actionMeta: "Riprova la connessione.",
        goToConnections: "Vai alle connessioni →",
      },
      whatsappModal: {
        title: {
          add: "Aggiungi WhatsApp",
          edit: "Modifica WhatsApp",
        },
        form: {
          name: "Nome",
          default: "Predefinita",
          farewellMessage: "Messaggio di congedo",
          n8nWebhookUrl: "Webhook n8n di questa connessione (opzionale)",
          n8nWebhookUrlHelp: "Se compilato, i messaggi in arrivo su questa linea vengono inviati a questo webhook (un bot dedicato per linea). Vuoto = usa il webhook dell'azienda.",
          backupConnection: "Connessione di riserva",
          noBackup: "Nessuna riserva",
          backupOf: "Questa connessione è riserva di:",
          unlinkBackup: "Scollega",
          isPrimary: "Questa connessione è la primaria",
        },
        buttons: {
          okAdd: "Aggiungi",
          okEdit: "Salva",
          cancel: "Annulla",
          next: "Avanti",
        },
        success: "WhatsApp salvato con successo.",
        meta: {
          phoneNumberId: "Phone Number ID",
          wabaId: "WABA ID",
          appId: "App ID",
          accessToken: "Access Token",
          whereToFind: "Trovalo in Meta Business → WhatsApp → Configurazione API",
          updateToken: "Aggiorna token",
          tokenHidden: "Token salvato ●●●●●●●●",
        },
      },
      qrCode: {
        message: "Scansiona il codice QR per avviare la sessione",
      },
      contacts: {
        title: "Contatti",
        toasts: {
          deleted: "Contatto eliminato con successo!",
        },
        searchPlaceholder: "Cerca...",
        confirmationModal: {
          deleteTitle: "Elimina",
          importTitlte: "Importa contatti",
          deleteMessage:
            "Sei sicuro di voler eliminare questo contatto? Tutte le chat correlate andranno perse.",
          importMessage: "Vuoi importare tutti i contatti dal telefono?",
        },
        buttons: {
          import: "Importa contatti",
          add: "Aggiungi contatto",
        },
        table: {
          name: "Nome",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Azioni",
        },
      },
      contactModal: {
        title: {
          add: "Aggiungi contatto",
          edit: "Modifica contatto",
        },
        form: {
          mainInfo: "Dati del contatto",
          extraInfo: "Informazioni aggiuntive",
          name: "Nome",
          number: "Numero WhatsApp",
          email: "Email",
          extraName: "Nome del campo",
          extraValue: "Valore",
        },
        buttons: {
          addExtraInfo: "Aggiungi informazione",
          okAdd: "Aggiungi",
          okEdit: "Salva",
          cancel: "Annulla",
        },
        success: "Contatto salvato con successo.",
      },
      quickAnswersModal: {
        title: {
          add: "Aggiungi risposta rapida",
          edit: "Modifica risposta rapida",
        },
        form: {
          shortcut: "Scorciatoia",
          message: "Risposta rapida",
        },
        buttons: {
          okAdd: "Aggiungi",
          okEdit: "Salva",
          cancel: "Annulla",
        },
        success: "Risposta rapida salvata con successo.",
      },
      queueModal: {
        title: {
          add: "Aggiungi coda",
          edit: "Modifica coda",
        },
        form: {
          name: "Nome",
          color: "Colore",
          greetingMessage: "Messaggio di benvenuto",
        },
        buttons: {
          okAdd: "Aggiungi",
          okEdit: "Salva",
          cancel: "Annulla",
        },
      },
      userModal: {
        title: {
          add: "Aggiungi utente",
          edit: "Modifica utente",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Password",
          profile: "Profilo",
          whatsapp: "Connessione predefinita",
          canSeeUnassigned: "Vedere chat non assegnate",
          canViewPhones: "Può vedere i numeri di telefono", canViewPhonesHelper: "Se disattivato, questo utente vede i numeri dei contatti mascherati (es. +549351●●●●482). Gli amministratori li vedono sempre completi.",
          allowedWhatsapps: "Connessioni consentite",
          allowedWhatsappsAll: "Tutte le connessioni",
          allowedWhatsappsHelp: "Se non ne selezioni nessuna, l'utente vedrà le chat di tutte le connessioni.",
        },
        buttons: {
          okAdd: "Aggiungi",
          okEdit: "Salva",
          cancel: "Annulla",
        },
        success: "Utente salvato con successo.",
      },
      chat: {
        noTicketMessage: "Seleziona un ticket per iniziare a conversare.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Nuovo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Reparti",
      },
      tickets: {
        noAccess: "Non hai accesso a questa chat.",
        toasts: {
          deleted: "La chat in cui ti trovavi è stata eliminata.",
        },
        notification: {
          message: "Messaggio da",
        },
        tabs: {
          open: { title: "Posta in arrivo" },
          closed: { title: "Risolti" },
          deleted: { title: "Eliminati" },
          search: { title: "Cerca" },
        },
        search: {
          placeholder: "Cerca chat e messaggi",
        },
        buttons: {
          showAll: "Tutti",
        },
        selectQueueModal: {
          title: "Da quale reparto vuoi rispondere?",
          subtitle: "Il ticket sarà assegnato a questo reparto",
          confirm: "Conferma",
          cancel: "Annulla",
        },
        selectWhatsappModal: {
          title: "Da quale connessione inviare?",
          subtitle: "Seleziona la connessione WhatsApp",
          confirm: "Conferma",
          cancel: "Annulla",
        },
        acceptedSuccess: "Ticket preso correttamente",
      },
      transferTicketModal: {
        title: "Trasferire conversazione",
        fieldUser: "Assegna a utente (opzionale)",
        fieldUserPlaceholder: "Cerca utente...",
        fieldQueue: "Reparto",
        fieldQueuePlaceholder: "Seleziona reparto...",
        fieldConnection: "Connessione",
        fieldNote: "Nota interna (opzionale)",
        fieldNotePlaceholder: "Scrivi un commento per l'agente che riceve la chat. Usa / per inserire risposte rapide.",
        fieldNoteHelper: "Questa nota sarà visibile solo agli agenti nella chat.",
        userNoQueueInfo: "Questo utente non ha un reparto assegnato. La conversazione verrà trasferita senza reparto.",
        transferButton: "Trasferire",
        cancelButton: "Annulla",
        disabledTooltip: "Seleziona un utente o un reparto per continuare",
        successToast: "Conversazione trasferita",
        noOptions: "Nessun utente trovato con quel nome",
        noteHeader: {
          title: "🔄 Trasferimento",
          fromTo: "Da: {{from}} → {{to}}",
          toQueue: "Reparto {{queue}}",
        },
        buttons: {
          ok: "Trasferire",
          cancel: "Annulla",
        },
      },
      ticketsList: {
        pendingHeader: "In attesa",
        // feat_340: el CHIP del zócalo (no el tab).
        pendingChipLabel: "Non letto",
        assignedHeader: "In gestione",
        pendingHeaderShort: "Attesa",
        assignedHeaderShort: "Gestione",
        noTicketsTitle: "Niente qui!",
        filters: {
          all: "Tutti",
          unassigned: "Non assegnati",
          none: "Filtri",
          tags: "Etichette",
          filtersLabel: "Filtri:",
          tagPlaceholder: "Etichetta",
          tagCount: "{{count}} etichette",
          tagCountOne: "1 etichetta",
          contactTypes: "Tipo Cliente",
          contactTypePlaceholder: "Tipo",
          contactTypeCount: "Tipo: {{count}} selezionati",
          contactTypeCountOne: "1 tipo selezionato",
          queuePlaceholder: "Reparto",
          queueCount: "{{count}} reparti",
          statePlaceholder: "Stato",
          userPlaceholder: "Utente",
          userCount: "{{count}} utenti",
          userUnassigned: "Non assegnato",
        },
        noQueue: "Nessun reparto",
        noTicketsMessage:
          "Nessuna chat trovata con questo stato o termine di ricerca",
        connectionTitle: "Connessione attualmente in uso.",
        contactsWithoutChat: "Contatti senza chat",
        startChat: "Avvia chat",
        group: "Gruppo",
        buttons: {
          accept: "Gestisci",
        },
        deletedView: {
          restoreBtn: "Ripristina",
          restoreOne: "Ripristina questa chat",
          hardDeleteBtn: "Elimina definitivamente",
          hardDeleteOne: "Elimina permanentemente",
        },
      },
      newTicketModal: {
        title: "Crea chat",
        fieldLabel: "Scrivi per cercare il contatto",
        add: "Aggiungi",
        toastExisting: "Esiste già una chat con {{name}} — apertura chat esistente",
        toastInOtherQueue: "Chat in coda \"{{queueName}}\" gestita da {{userName}}. Chiedi un trasferimento.",
        otherAgent: "un altro operatore",
        inOtherQueueActive: "Questa chat è gestita da {{userName}} nella coda \"{{queueName}}\". Chiedigli di trasferirtela.",
        inOtherQueueClosed: "Questa chat appartiene alla coda \"{{queueName}}\" e non hai accesso.",
        toastNoConnection: "Nessuna connessione WhatsApp attiva disponibile",
        buttons: {
          ok: "Salva",
          cancel: "Annulla",
        },
      },
      mainDrawer: {
        listItems: {
          crmBoard: "Funnel",
          dashboard: "Dashboard",
          announcements: "Comunicazioni",
          connections: "Connessioni",
          tickets: "Chat",
          contacts: "Contatti",
          quickAnswers: "Risposte rapide",
          queues: "Reparti",
          administration: "Amministrazione",
          users: "Team",
          settings: "Impostazioni",
        },
        appBar: {
          user: {
            profile: "Profilo",
            logout: "Esci",
            darkMode: "Modalità scura",
            density: "Densità",
            densityCompact: "Compatto",
            densityNormal: "Normale",
            densityComfortable: "Ampio",
          },
        },
        sidebar: {
          pin: "Fissa menu",
          unpin: "Sblocca menu",
        },
      },
      notifications: {
        noTickets: "Nessuna notifica.",
      },
      queues: {
        title: "Reparti",
        table: {
          name: "Nome",
          color: "Colore",
          greeting: "Messaggio di benvenuto",
          actions: "Azioni",
        },
        buttons: {
          add: "Aggiungi reparto",
        },
        confirmationModal: {
          deleteTitle: "Elimina",
          deleteMessage:
            "Sei sicuro? Questa azione non può essere annullata. I ticket di questa coda continueranno a esistere senza coda assegnata.",
        },
      },
      queueSelect: {
        inputLabel: "Reparti",
      },
      quickAnswers: {
        title: "Risposte rapide",
        table: {
          shortcut: "Scorciatoia",
          message: "Risposta rapida",
          actions: "Azioni",
        },
        buttons: {
          add: "Aggiungi risposta rapida",
        },
        toasts: {
          deleted: "Risposta rapida eliminata con successo.",
        },
        searchPlaceholder: "Cerca...",
        confirmationModal: {
          deleteTitle: "Sei sicuro di voler eliminare questa risposta rapida: ",
          deleteMessage: "Questa azione non può essere annullata.",
        },
      },
      users: {
        title: "Team",
        table: {
          name: "Nome",
          email: "Email",
          profile: "Profilo",
          whatsapp: "Connessione predefinita",
          actions: "Azioni",
        },
        buttons: {
          add: "Aggiungi membro del team",
        },
        toasts: {
          deleted: "Utente eliminato con successo.",
        },
        confirmationModal: {
          deleteTitle: "Elimina",
          deleteMessage:
            "Tutti i dati dell'utente andranno persi. I ticket aperti verranno spostati nella coda.",
        },
      },
      companies: {
        secretariaIaSuperadminLabel: "Segretaria IA",
        secretariaIaSuperadminHelp: "Abilita la Segretaria IA per questa azienda. Se disattivata, nessuna IA risponderà.",
        iaAdminCanToggleLabel: "Consenti il controllo all'amministratore",
        iaAdminCanToggleHelp: "Se attivo, l'amministratore di questa azienda può accendere o spegnere l'IA dal suo pannello.",
      },
      ia: {
        toolbarActiveTooltip: "IA accesa — clic per spegnere",
        toolbarInactiveTooltip: "IA spenta — clic per accendere",
        toolbarTurnosNote: "Solo Segretaria/Venditore IA: l'assistente di TurnosIA ha il proprio interruttore (TurnosIA › Impostazioni).",
        menuSecretariaLabel: "Segretaria IA",
        menuVendedorLabel: "Venditore IA",
        vendedorDisabledTooltip: "Attiva prima la Segretaria IA",
      },
      settings: {
        success: "Impostazione salvata con successo.",
        businessInfo: {
          title: "Dati dell'attività",
          subtitle: "Informazioni che l'IA usa in ogni conversazione con i clienti.",
          address: "Indirizzo",
          phone: "Telefono",
          whatsapp: "WhatsApp di contatto",
          email: "Email di contatto",
          locationLink: "Link di Google Maps",
          hoursText: "Orari in testo libero",
          hoursTextHelp: "Es: Lun-Ven 9-18. Testo che l'IA può leggere al cliente.",
          timezone: "Fuso orario",
        },
        businessHours: {
          title: "Orario di lavoro",
          always247Label: "Disponibile 24/7",
          always247Helper: "Se attivo, l'azienda è considerata sempre disponibile indipendentemente dall'orario configurato.",
          scheduleLabel: "Orario di apertura",
          scheduleHelper: "Definisce i giorni e gli orari in cui l'azienda è disponibile a ricevere richieste. Usato per il carrello abbandonato e altre automazioni.",
        },
        title: "Impostazioni",
        secretariaIaSuperadminLabel: "Segretaria IA",
        secretariaIaSuperadminHelp: "Abilita la Segretaria IA per questa azienda. Se disattivata, nessuna IA risponderà.",
        vendedorIaSuperadminLabel: "Venditore IA",
        vendedorIaSuperadminHelp: "Abilita il Venditore IA. Richiede la Segretaria IA attiva.",
        iaAdminCanToggleLabel: "Consenti il controllo all'amministratore",
        iaAdminCanToggleHelp: "Se attivo, l'amministratore dell'azienda può accendere o spegnere l'IA dal suo pannello.",
        secretariaIaLabel: "Segretaria IA",
        aiSilenceOnTicketOpenLabel: "Silenzia IA quando si prende in carico il ticket",
        aiSilenceOnTicketOpenHelp: "Se attivo, quando un operatore prende (apre) un ticket l'IA smette subito di rispondere a quel contatto, senza attendere che l'operatore scriva. Alla chiusura del ticket l'IA si riattiva.",
        aiActivateOnlyOnClose: "IA solo alla chiusura",
        aiActivateOnlyOnCloseDesc: "Se attivo, l'IA non risponde durante i trasferimenti tra operatori o reparti. Riprende solo quando il ticket viene chiuso e il contatto scrive di nuovo.",
        secretariaIaHelp: "Controlla se la Segretaria IA risponde ai messaggi in arrivo.",
        vendedorIaLabel: "Venditore IA",
        vendedorIaHelp: "Controlla se il Venditore IA prende in carico i contatti qualificati.",
        vendedorIaDisabledTooltip: "Attiva prima la Segretaria IA",
        iaControlSectionTitle: "Intelligenza Artificiale",
        iaActiveStatus: "Stato attuale",
        iaStatusOn: "Accesa",
        iaStatusOff: "Spenta",
        iaScheduleSectionTitle: "Orario automatico IA",
        iaScheduleEnabledLabel: "Attiva l'IA automaticamente fuori orario",
        iaScheduleEnabledHelp: "L'IA si accenderà da sola al termine dell'orario di lavoro. Non si spegne automaticamente all'inizio dell'orario.",
        settings: {
          userCreation: {
            name: "Creazione utenti",
            options: {
              enabled: "Abilitato",
              disabled: "Disabilitato",
            },
          },
          n8nWebhookUrl: {
            name: "URL Webhook n8n",
          },
          n8nToken: {
            name: "Token n8n",
          },
          n8nTimeout: {
            name: "Timeout (secondi)",
          },
          n8nRetries: {
            name: "Tentativi",
          },
          n8nPrompt: {
            name: "Prompt IA",
          },
        },
      },
      messagesList: {
        forwarded: "Inoltrato",
        unsupportedMessage: "Messaggio non compatibile",
        historyMediaUnavailable: "📎 File della cronologia non disponibile",
        forwardedMany: "Inoltrato molte volte",
        header: {
          assignedTo: "Assegnato a:",
          buttons: {
            return: "Restituisci",
            resolve: "Risolvi",
            reopen: "Riapri",
            accept: "Gestisci",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Scrivi un messaggio o premi '/' per usare le risposte rapide",
        placeholderClosed: "Riapri o accetta questo ticket per inviare un messaggio.",
        signMessage: "Firma",
        captionPlaceholder: "Aggiungi un commento...",
        cancelMedia: "Annulla",
        sendMedia: "Invia",
        dropFileHere: "Rilascia il file qui",
      },
      contactDrawer: {
        header: "Dati del contatto",
        buttons: {
          edit: "Modifica contatto",
        },
        extraInfo: "Informazioni aggiuntive",
      },
      ticketActionButtons: {
        exportTooltip: "Scarica conversazione (TXT)",
      },
      ticketOptionsMenu: {
        delete: "Elimina",
        transfer: "Trasferisci",
        assignReason: "Assegna motivo",
        scheduleFollowUp: "Programma follow-up",
        confirmationModal: {
          title: "Eliminare la conversazione con {{name}}?",
          message: "La chat andrà in Eliminati. Puoi ripristinarla da lì.",
        },
        buttons: {
          delete: "Elimina",
          cancel: "Annulla",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Conferma",
          cancel: "Annulla",
        },
      },
      messageOptionsMenu: {
        delete: "Elimina",
        reply: "Rispondi",
        confirmationModal: {
          title: "Eliminare il messaggio?",
          message: "Questa azione non può essere annullata.",
        },
      },
      backendErrors: {
        ERR_CONTACT_IMPORT_EMPTY: "Il file è vuoto o non ha righe.",
        ERR_CONTACT_IMPORT_TOO_LARGE: "Il file supera i 5 MB.",
        ERR_CONTACT_IMPORT_TOO_MANY_ROWS: "Il file ha più di 10.000 righe. Dividilo in parti.",
        ERR_CONTACT_IMPORT_TOO_MANY_COLUMNS: "Il file ha troppe colonne (massimo 60).",
        ERR_CONTACT_IMPORT_NOT_CSV: "Il file non sembra un CSV. Se è un Excel, salvalo prima come CSV.",
        ERR_CONTACT_IMPORT_BAD_OPTIONS: "Opzioni di importazione non valide.",
        ERR_CONTACT_IMPORT_BAD_MAPPING: "La mappatura delle colonne non è valida.",
        ERR_CONTACT_IMPORT_DUPLICATE_FIELD: "Ogni dato (nome, numero, email…) può provenire da una sola colonna.",
        ERR_CONTACT_IMPORT_NUMBER_REQUIRED: "Scegli la colonna del numero di telefono.",
        ERR_CONTACT_IMPORT_IN_PROGRESS: "C'è già un'importazione in corso per la tua azienda. Attendi che finisca.",
        ERR_TICKET_TRANSFER_NOT_ALLOWED: "Non hai il permesso di trasferire questo ticket.",
        ERR_QUEUE_NOT_FOUND: "Reparto non trovato.",
        ERR_CRM_DISABLED: "Il Funnel non è attivo per questa azienda.",
        ERR_SUPPORT_NOT_ALLOWED: "Solo gli amministratori dell'azienda possono usare l'Assistenza.",
        ERR_SUPPORT_DISABLED: "L'Assistenza non è attiva per questa azienda.",
        ERR_SUPPORT_FLAG_SUPERADMIN_ONLY: "Solo il team WAIA può attivare o disattivare l'Assistenza.",
        ERR_SUPPORT_FLAG_INVALID_VALUE: "Valore non valido per attivare l'Assistenza.",
        ERR_SUPPORT_TEXT_REQUIRED: "Scrivi la tua richiesta.",
        ERR_SUPPORT_TEXT_TOO_LONG: "La richiesta non può superare i 2000 caratteri.",
        ERR_SUPPORT_INVALID_TICKET: "Il ticket indicato non è valido.",
        ERR_SUPPORT_INVALID_CONTACT: "Il contatto indicato non è valido.",
        ERR_SUPPORT_INVALID_WHATSAPP: "La connessione indicata non è valida.",
        ERR_SUPPORT_TICKET_NOT_FOUND: "Non abbiamo trovato quel ticket nella tua azienda.",
        ERR_SUPPORT_CONTACT_NOT_FOUND: "Non abbiamo trovato quel contatto nella tua azienda.",
        ERR_SUPPORT_WHATSAPP_NOT_FOUND: "Non abbiamo trovato quella connessione nella tua azienda.",
        ERR_SUPPORT_RATE_LIMIT: "Hai inviato molte richieste in poco tempo. Riprova tra un po’.",
        ERR_SUPPORT_REQUEST_NOT_FOUND: "Non abbiamo trovato quella richiesta.",
        ERR_SUPPORT_REQUEST_CLOSED: "Questa richiesta è chiusa. Se ti serve altro, aprine una nuova.",
        ERR_SUPPORT_TOO_MANY_ATTACHMENTS: "Puoi allegare fino a 3 immagini per richiesta.",
        ERR_SUPPORT_ATTACHMENT_TOO_LARGE: "Ogni immagine può pesare al massimo 5 MB.",
        ERR_SUPPORT_ATTACHMENT_INVALID_TYPE: "Sono accettate solo immagini PNG, JPG o WebP.",
        ERR_SUPPORT_ATTACHMENT_NOT_FOUND: "Non abbiamo trovato quell'immagine.",
        ERR_SUPPORT_INVALID_PAYLOAD: "Non siamo riusciti a leggere il modulo. Riprova.",
        ERR_CRM_NEEDS_ACTIVE_STATES: "Il Funnel richiede almeno uno stato di contatto attivo.",
        ERR_ENTRY_STAGE_MUST_BE_ACTIVE: "Solo una fase attiva può essere l'ingresso del Funnel.",
        ERR_LOST_REASON_NOT_FOUND: "Il motivo di perdita scelto non esiste.",
        ERR_INVALID_SETTING_VALUE: "Valore di configurazione non valido.",
        ERR_INVALID_PARAM: "Parametro non valido.",
        // feat_210 estándar — motor + modo estándar/a medida + Excel modelo
        ERR_TEMPLATE_VAR_MISMATCH: "Il modello non ha lo stesso numero di variabili del profilo di invio.",
        ERR_TEMPLATE_VARS_EXCEED_PROFILE: "Il modello ha più variabili di quelle ammesse dal profilo di invio.",
        ERR_INVALID_HEADER_MATCH: "Configurazione del profilo non valida: modalità delle intestazioni sconosciuta.",
        ERR_INVALID_TEXT_COLUMNS: "Configurazione del profilo non valida: colonne di testo definite male.",
        ERR_INVALID_PHONE_PARSER: "Configurazione del profilo non valida: lettore di telefoni sconosciuto.",
        ERR_INVALID_DEFAULT_COUNTRY: "Configurazione del profilo non valida: paese predefinito non supportato.",
        ERR_INVALID_REQUIRED_FOR_VAR: "Configurazione del profilo non valida: requiredForVar deve essere un intero maggiore o uguale a 1.",
        ERR_INVALID_TEMPLATE_VARS_MODE: "Configurazione del profilo non valida: modalità delle variabili sconosciuta.",
        ERR_INVALID_MAX_VARS: "Numero di variabili del modello non valido.",
        ERR_NO_FREE_SLOT: "Non c'è uno slot libero in Caricamento Dati: sono occupati tutti e 4.",
        ERR_STANDARD_NOT_ENABLED: "L'Excel standard non è abilitato per questa azienda.",
        ERR_INVALID_STANDARD_MODE: "Modalità di caricamento dati non valida.",
        ERR_STANDARD_PROFILE_NOT_FOUND: "Questa azienda non ha abilitato l'Excel standard.",
        ERR_OUTBOUND_PAUSED: "Gli invii di questa connessione sono IN PAUSA: il messaggio non è stato inviato. Riattivali da Connessioni.",
        ERR_INVALID_PAUSED_VALUE: "Valore non valido per mettere in pausa gli invii.",
        // feat_299 — "Ver como usuario"
        ERR_VIEW_AS_INVALID_ID: "L'utente indicato per \"Visualizza come\" non è valido.",
        ERR_VIEW_AS_REQUIRES_ADMIN: "Solo un amministratore può usare \"Visualizza come utente\".",
        ERR_VIEW_AS_USER_NOT_FOUND: "Utente non trovato nella tua azienda.",
        ERR_VIEW_AS_INVALID_TARGET: "Non puoi visualizzare come un altro amministratore.",
        ERR_PINNED_WHATSAPP_DISCONNECTED: "La connessione assegnata a questa conversazione è disconnessa. Riconnettila per poter rispondere.",
        ERR_OPT_IN_REQUIRED: "Devi confermare il consenso dei destinatari.",
        ERR_TEMPLATE_HEADER_VARS_NOT_SUPPORTED: "Il modello ha variabili fuori dal corpo (intestazione o pulsante), non supportate.",
        ERR_TEMPLATE_HEADER_MEDIA_REQUIRED: "Questo modello richiede un file nell'intestazione: allega il file per poterlo inviare.",
        ERR_TEMPLATE_HEADER_MEDIA_NOT_SUPPORTED: "Questo modello non accetta allegati: la sua intestazione è di testo.",
        ERR_TEMPLATE_HEADER_MEDIA_TYPE_MISMATCH: "Il file non corrisponde al tipo di intestazione del modello.",
        ERR_TEMPLATE_HEADER_MEDIA_UPLOAD_FAILED: "Non è stato possibile caricare il file su Meta. Riprova tra qualche minuto.",
        ERR_TEMPLATE_HEADER_MEDIA_SAMPLE_MISSING: "Questo modello ha un'immagine/file nell'intestazione ma Meta non ha restituito l'esempio approvato. Sincronizza i modelli e riprova.",
        ERR_TEMPLATE_HEADER_SAMPLE_REQUIRED: "Carica un file di esempio: Meta lo richiede per approvare un modello con intestazione di file.",
        ERR_TEMPLATE_HEADER_SAMPLE_UPLOAD_FAILED: "Non è stato possibile caricare il file di esempio su Meta. Riprova tra qualche minuto.",
        ERR_BULK_IMPORT_IN_PROGRESS: "C'è già un invio massivo in corso per questa azienda.",
        ERR_WHATSAPP_NOT_CONNECTED: "La connessione selezionata non è collegata.",
        ERR_NOT_META_CONNECTION: "La connessione selezionata non è di Meta.",
        ERR_TEMPLATE_NOT_APPROVED: "Il modello non è approvato da Meta.",
        ERR_PROFILE_NOT_FOUND: "Profilo di invio non trovato.",
        ERR_BULK_IMPORT_NOT_FOUND: "Invio massivo non trovato.",
        ERR_BULK_IMPORT_NOT_CANCELLABLE: "L'invio non può essere annullato nel suo stato attuale.",
        ERR_BULK_IMPORT_NOT_RETRYABLE: "L'invio non ammette un nuovo tentativo nel suo stato attuale.",
        ERR_META_CONSECUTIVE_FAILURES: "L'invio è stato messo in pausa per errori consecutivi di Meta.",
        ERR_META_BILLING_MISSING: "Invio non riuscito: manca il metodo di pagamento in Meta. Aggiungi una carta nel Centro fatturazione.",
        ERR_WHATSAPP_NOT_FOUND: "Connessione non trovata.",
        ERR_TEMPLATE_NOT_FOUND: "Modello non trovato.",
        ERR_FILE_REQUIRED: "File mancante.",

        ERR_NO_OTHER_WHATSAPP: "Deve esistere almeno una connessione WhatsApp predefinita.",
        ERR_NO_DEF_WAPP_FOUND:
          "WhatsApp predefinito non trovato. Verifica la pagina delle connessioni.",
        ERR_WAPP_NOT_INITIALIZED:
          "Questa sessione WhatsApp non è inizializzata. Verifica la pagina delle connessioni.",
        ERR_WAPP_CHECK_CONTACT:
          "Impossibile verificare il contatto WhatsApp. Verifica la pagina delle connessioni.",
        ERR_WAPP_INVALID_CONTACT: "Questo non è un numero WhatsApp valido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Impossibile scaricare i file WhatsApp. Verifica la pagina delle connessioni.",
        ERR_INVALID_CREDENTIALS: "Errore di autenticazione. Riprova.",
        ERR_SENDING_WAPP_MSG:
          "Errore nell'invio del messaggio WhatsApp. Verifica la pagina delle connessioni.",
        ERR_DELETE_WAPP_MSG: "Impossibile eliminare il messaggio WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Esiste già un ticket aperto per questo contatto.",
        ERR_SESSION_EXPIRED: "Sessione scaduta. Accedi nuovamente.",
        ERR_USER_CREATION_DISABLED:
          "La creazione di utenti è stata disabilitata dall'amministratore.",
        ERR_NO_PERMISSION: "Non hai il permesso di accedere a questa risorsa.",
        ERR_TICKET_LOCKED_BY_OTHER_AGENT: "Questo ticket è in gestione da un altro operatore. Non puoi scrivere.",
        ERR_REQUIRES_SUPER_SUPERADMIN: "Solo il superadmin principale può eseguire questa azione.",
        ERR_COMPANY_OUT_OF_SCOPE: "Questa azienda non appartiene al tuo marchio.",
        ERR_FEATURE_NOT_ALLOWED: "Non hai il permesso di accedere a questa sezione.",
        ERR_CANNOT_CHANGE_INSTANCE_ID: "Non puoi cambiare il marchio di un'azienda al di fuori del tuo.",
        ERR_RESELLER_HAS_NO_WHITELABEL: "Questo reseller non ha un marchio assegnato.",
        ERR_INVALID_TARGET_COMPANIES: "Puoi inviare avvisi solo alle aziende del tuo marchio.",
        ERR_TEMPLATE_VARS_MISMATCH: "Mancano esempi: inserisci un esempio per ogni variabile del template.",
        ERR_TEMPLATE_VARS_SEQUENCE: "Le variabili devono essere consecutive da {{1}} (senza salti).",
        ERR_DUPLICATED_CONTACT: "Esiste già un contatto con questo numero.",
        ERR_USER_EMAIL_EXISTS: "Questa email è già registrata in questa azienda.",
        ERR_PHONE_MASKED: "Non è possibile usare un numero mascherato.",
        ERR_NO_SETTING_FOUND: "Nessuna impostazione trovata con questo ID.",
        ERR_NO_CONTACT_FOUND: "Nessun contatto trovato con questo ID.",
        ERR_NO_TICKET_FOUND: "Nessun ticket trovato con questo ID.",
        ERR_NO_USER_FOUND: "Nessun utente trovato con questo ID.",
        ERR_NO_WAPP_FOUND: "Nessun WhatsApp trovato con questo ID.",
        ERR_CREATING_MESSAGE: "Errore nella creazione del messaggio nel database.",
        ERR_CREATING_TICKET: "Errore nella creazione del ticket nel database.",
        ERR_FETCH_WAPP_MSG:
          "Errore nel recupero del messaggio WhatsApp, potrebbe essere molto vecchio.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Questo colore è già in uso, scegline un altro.",
        ERR_WAPP_GREETING_REQUIRED:
          "Il messaggio di benvenuto è obbligatorio quando ci sono più code.",
        ERR_META_INVALID_CREDENTIALS:
          "Credenziali Meta non valide. Controlla Access Token e Phone Number ID.",
        ERR_META_WINDOW_EXPIRED:
          "Finestra di 24 ore scaduta. Il cliente deve scrivere per primo.",
        ERR_META_NUMBER_NOT_WA:
          "Questo numero non ha un account WhatsApp attivo.",
        ERR_WHATSAPP_ALREADY_LINKED:
          "Questa connessione è già collegata ad un'altra. Scollegala prima.",
        ERR_META_PHONE_ALREADY_LINKED:
          "Questo numero Meta è già collegato in un'altra azienda. Uno stesso numero non può stare in due aziende.",
      },
      errors: {
        metaWindowExpired: "⚠️ Finestra di 24 ore scaduta. Il cliente deve scrivere per primo per riprendere la conversazione, oppure usa un template per avviarla.",
      },
    },
  },
};

export { messages };
